import { createOrganization, listOrganizations, setActiveOrganization } from '../../lib/auth-client';
import type { OrganizationDetailsFormState } from './OrganizationDetailsForm';

type OrganizationRecord = {
  id: string | number;
};

type CreateAndActivateOrganizationOptions = {
  form: OrganizationDetailsFormState;
  refreshSession?: () => Promise<unknown> | unknown;
  previousOrganizations?: OrganizationRecord[];
};

export async function createAndActivateOrganization({
  form,
  refreshSession,
  previousOrganizations = [],
}: CreateAndActivateOrganizationOptions) {
  const previousOrganizationIds = new Set((previousOrganizations ?? []).map((organization) => String(organization.id)));

  const createdOrganizationResponse = (await createOrganization({
    name: form.organizationName.trim(),
    billingAddressStreet: form.billingAddressStreet.trim(),
    billingAddressStreetNumber: form.billingAddressStreetNumber.trim(),
    billingAddressPostalCode: form.billingAddressPostalCode.trim(),
    billingAddressCountry: form.billingAddressCountry.trim(),
  })) as any;

  const createdOrganizationId =
    createdOrganizationResponse?.id ||
    createdOrganizationResponse?.organization?.id ||
    createdOrganizationResponse?.data?.id ||
    createdOrganizationResponse?.data?.organization?.id;

  const organizationsResponse = await listOrganizations();
  const organizations = Array.isArray(organizationsResponse) ? organizationsResponse : [];
  const newOrganization =
    (createdOrganizationId != null
      ? organizations.find((organization) => String(organization.id) === String(createdOrganizationId))
      : undefined) || organizations.find((organization) => !previousOrganizationIds.has(String(organization.id)));

  if (!newOrganization?.id) {
    throw new Error('Unable to resolve the newly created organization');
  }

  await setActiveOrganization(newOrganization.id);
  await refreshSession?.();

  return {
    organizations,
    newOrganizationId: newOrganization.id,
  };
}
